/**
 * User: n.gorte
 * Date: 21.10.2020
 * Time: 12:34
 */

const svgText = ({ text, color, fontWeight, textDecoration, fontSize }) => {
    return `
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="150" height="30" fill="white">
                        <text x="50%" y="50%" 
                        dominant-baseline="middle" 
                        text-anchor="middle" 
                        fill="${color}" 
                        font-size="${fontSize || 12}" 
                        font-weight="${fontWeight}"
                        text-decoration="${textDecoration}"
                        >
                            ${text}
                        </text>
                    </svg>
            `;
};

export const svgMarkers = ({ text, color, fontWeight, textDecoration, fontSize }) => {
    return 'data:image/svg+xml,' + encodeURIComponent(svgText({ text, color, fontWeight, textDecoration, fontSize }));
};

export const svgMarkerIcon = (fill = '#7A8BE7') =>  `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
   width="32.574287"
   height="50.542145"
    >   
    <g transform="matrix(0.09285714,0,0,0.09285714,-0.69642859,-0.71500113)">
        <g>
            <path d="m 182.9,551.7 c 0,0.1 0.19999,0.3 0.19999,0.3 C 183.09999,552 358.3,283 358.3,194.6 358.3,64.5 269.5,7.900009 182.9,7.700012 96.3,7.9 7.5,64.5 7.5,194.6 7.5,283 182.8,552 182.8,552 c 0,0 0.1,-0.3 0.1,-0.3 z M 122.2,187.2 c 0,-33.6 27.2,-60.80001 60.8,-60.80001 33.6,0 60.8,27.2 60.8,60.80001 0,33.6 -27.3,60.8 -60.9,60.8 -33.5,0 -60.7,-27.2 -60.7,-60.8 z" stroke="none" fill="${fill}" fill-rule="nonzero" />
        </g>
    </g>
    </svg>
`;



// WEBPACK FOOTER //
// ./js/plugins/DrawerPlugin/SvgMarkers.js